import React, { useState } from 'react';
import '../styles/Contact.css';
import ScrollToTop from './ScrollToTop';
import ThemeToggleButton from './ThemeToggleButton';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // 실제 폼 제출 로직은 여기에 구현해야 합니다.
    // 예를 들어, 이메일 전송 API를 호출할 수 있습니다.
    alert('문의가 접수되었습니다. 감사합니다!');
    setName('');
    setEmail('');
    setMessage('');
  };

  return (
    <>
      <div className="contact-container">
        <div className="contact-header">
          <h1>문의하기</h1>
          <p>서비스에 대한 궁금한 점이나 개선 제안 등 어떤 내용이든 좋습니다.</p>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">이름</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">이메일</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">문의 내용</label>
            <textarea
              id="message"
              rows="6"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-button">보내기</button>
        </form>
      </div>
    <ThemeToggleButton />
    <ScrollToTop />
    </>
  );
};

export default Contact;
